
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(193|227|244|313|431|471|849)$/.test(chunkId);
},
rootOutputDir: "../",

    };
}
